/**
 * This map serves as a way to overwrite any of our module-specific
 * or other funky iso names coming from the LocalizationPlatform
 */
export default {
    // Defaulting to English for our development langs
    pseudo: 'en',
    'primary-value': 'en',
    'string-key': 'en',
};
//# sourceMappingURL=locale-map.js.map